import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subProject",
  "use": "icon-subProject-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-subProject\">\n  <path d=\"M8.40226 6.96429V11.6447L6.59774 11.2049V4.76504L3.66541 1.46617H11.3346L8.40226 4.69173V6.96429ZM9.86842 5.42481L15 0H0L5.13158 5.42481V12.0113L9.86842 14.2105V5.42481Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol